/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./appcenter.vue?vue&type=template&id=0c84a1c6&scoped=true"
import script from "./appcenter.vue?vue&type=script&lang=js"
export * from "./appcenter.vue?vue&type=script&lang=js"
import style0 from "./appcenter.vue?vue&type=style&index=0&id=0c84a1c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c84a1c6",
  null
  
)

export default component.exports